export default class StringUtils {
  /**
   * 文字列に変換
   * @param val any
   * @returns 値を文字列に変換する
   */
  static toString(val) {
    if (typeof val === 'undefined' || val === null) {
      return ''
    }
    return val.toString().trim()
  }
  /**
   * 小文字に変換
   * @param val string
   * @returns 小文字に変換された呼び出し文字列値。
   */
  static toLowerCase(val) {
    if (!val) {
      return ''
    }
    return val.toLowerCase().trim()
  }
  /**
   * エスケープされた改行文字を実際の改行に変換します。
   * @param {string} text 変換される文字列
   * @returns 「\n」を含む文字列を返します
   */
  static unescapeNewLineChar(text) {
    return text && text.toString().replace(/\\n/g, '\n')
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/string.util.js